module.exports = __webpack_public_path__ + "static/media/integration-one.e7604f5a.svg";